import { ShieldCheck } from '@velocity-exchange/icons';
import SideDrawer from './BaseDrawers/SideDrawer/SideDrawer';
import Divider from '../primitives/Divider/Divider';
import Button from '../primitives/Button/Button';
import WarningFilled from 'src/components/Icons/WarningFilled';
import { getColorVar } from 'src/utils/theme/colorVars';
import Link from '../primitives/Link/Link';

const VAULTS_APPLICATION_FORM_URL =
	'https://docs.google.com/forms/d/e/1FAIpQLSeC64AEy84bQfBquJLc5cWAv2HxslnK0Aik4ezMf9Ubh-hK5g/viewform';

export const ListYourVaultDrawer = () => {
	return (
		<SideDrawer.Container drawerName="listYourVault">
			<SideDrawer.Title>List your vault</SideDrawer.Title>
			<SideDrawer.Body className="text-text-default">
				<div className="typo-label-sm">
					Velocity recognizes two types of Vault Managers:
				</div>

				<div className="flex flex-col gap-1">
					<h5 className="typo-label-xs">Ecosystem Vault Managers</h5>
					<p className="typo-body-xs text-text-secondary">
						These managers have met Velocity’s Strategy Vaults onboarding
						criteria. While Strategy Vaults on Velocity are permissionless
						(allowing anyone with the technical expertise to create and manage
						one), only those who successfully complete onboarding will be listed
						on the Velocity Strategy Vaults page.
					</p>
				</div>

				<div className="flex flex-col gap-1">
					<span className="flex items-center gap-1">
						<h5 className="typo-label-xs">Verified Vault Managers </h5>
						<ShieldCheck color={getColorVar('text-default')} />
					</span>
					<p className="typo-body-xs text-text-secondary">
						These managers go a step further by submitting basic KYB
						documentation in addition to meeting the Ecosystem Vault Manager
						criteria. These additional checks aim to enhance accountability and
						transparency for vault depositors.
					</p>
				</div>

				<Divider />

				<div className="flex flex-col gap-1">
					<span className="flex items-center gap-1">
						<h5 className="typo-label-xs">How to apply?</h5>
					</span>
					<p className="typo-body-xs text-text-secondary">
						To apply for listing on the Velocity Strategy Vaults page as an
						Ecosystem Vault Manager or Verified Vault Manager, please complete
						the following{' '}
						<Link href={VAULTS_APPLICATION_FORM_URL} openInNewTab>
							Form
						</Link>{' '}
						or by clicking the button below this side panel.
					</p>
				</div>

				<Divider />

				<div className="flex flex-row items-center gap-xs text-star-yellow">
					<WarningFilled size={16} />
					<h3 className="typo-label-sm">Before Applying, Please Note:</h3>
				</div>

				<div className="flex flex-col gap-1">
					<span className="flex items-center gap-1">
						<h5 className="typo-label-xs">
							Ecosystem Vault Manager Requirements:
						</h5>
					</span>
					<ul className="typo-body-xs text-text-secondary">
						<li>• Minimum $200K USD in capital to seed the first Vault</li>
						<li>• Proven experience in vault management</li>
						<li>• Clear description of the initial vault strategy</li>
						<li>• High-level distribution plan for attracting depositors</li>
					</ul>
				</div>

				<div className="flex flex-col gap-1">
					<span className="flex items-center gap-1">
						<h5 className="typo-label-xs">
							Verified Vault Manager Requirements:
						</h5>
					</span>
					<ul className="typo-body-xs text-text-secondary">
						<li>• Fulfill all Ecosystem Vault Manager requirements</li>
						<li>
							• Submit basic KYB documentation for the entity operating the
							Vault
						</li>
					</ul>
				</div>
			</SideDrawer.Body>
			<SideDrawer.Footer>
				<Button
					as="a"
					href={VAULTS_APPLICATION_FORM_URL}
					openInNewTab
					size="lg"
					className="w-full"
				>
					View Form
				</Button>
			</SideDrawer.Footer>
		</SideDrawer.Container>
	);
};
